<script>
export default {
  name: 'HomeComponent',
  components: {
  },
  data: function () {
    return {
      cycle: false,
      items: [
        {
          src: '/static/img/slides/1.jpg',
          title: 'Celebrating 25 years',
          text: '1993-2018'
        },
        {
          src: '/static/img/slides/2.jpg',
          title: 'A well equipped Radiator Repair & Machine Shop'
        },
        {
          src: '/static/img/slides/3.jpg',
          title: 'Labrador West #1 Industrial Radiator Repair Shop'
        },
        {
          src: '/static/img/slides/4.jpg',
          title: 'We are located in Wabush Industrial Park'
        }
      ]
    }
  }
}
</script>
<template>

  <section section id="home">
    <v-carousel :cycle="cycle">
    <v-carousel-item
      v-for="(item,i) in items"
      :key="i"
      :src="item.src"
    >
    <div class="welcome">
        <h1>{{ item.title }}</h1>
        <h1 v-if="item.text"><strong>{{ item.text }}</strong></h1>

          <scrollactive
        :offset="60"
        :duration="800"
        bezier-easing-value=".5,0,.35,1">

      </scrollactive>

    </div>
    </v-carousel-item>
  </v-carousel>
      <v-container grid-list-lg class="maxed">
        <v-layout row wrap>
          <v-flex xs12>
            <header>
              <h1>A well equipped Radiator Repair &amp; Machine Shop</h1>
            </header>
          </v-flex>

          <v-flex xs12 md4>
            <figure class="bio">
              <img src="/static/img/robert_bio.jpg" alt="Robert P. Wellon">
              <figcaption>Robert P. Wellon <span>1939 - 2017</span></figcaption></figure>
          </v-flex>

          <v-flex xs12 md8 id="about">
            <h2>LCR Plus Ltd.: Radiator Repair and Machine Shop Work in Labrador</h2>
            <p>Originally opened in 1993 by Robert P. Wellon, primarily as an industrial radiator repair shop, LCR Plus Ltd. has grown to a fully operational industrial shop consisting of 3 lathes, drill press, saw, sand blaster, threader and steam pressure washer.  In addition to testing, repairing and recoring automotive and industrial radiators, we can cut, groove, repair rubber ends of and rubber line pipe up to 24". We offer pipe products including elbows, couplings and flanges.  We also do metal fabrication and re-fabrication, and rebuild most industrial components and machines. </p>
          </v-flex>

          <v-flex xs12>
            <div class="quote">Labrador West #1 Industrial Radiator Repair Shop</div>
          </v-flex>

        </v-layout>
      </v-container>
  </section>
</template>



// WEBPACK FOOTER //
// src/components/Home.vue